import React, { useEffect, useState } from 'react';
import { FaCalendarAlt } from 'react-icons/fa';
import axios from 'axios';
import swal from 'sweetalert';
import { formatDate, formatDate01 } from '../../helper/helper';
import AttendanceCalendar from '../../component/Panel/AttendanceCalendar';
import AttendanceDetailModal from '../../component/Panel/AttendanceDetailModal';

const Histori = ({ data }) => {
    const [dateCurrent, setDateCurrent] = useState(new Date())
    const [dataAbsensi, setDataAbsensi] = useState(null);
    const [hariLibur, setHariLibur] = useState([]);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalData, setModalData] = useState(null);
    const [activeStartDate, setActiveStartDate] = useState(new Date());
    const [exporting, setExporting] = useState(false);

    const getData = async (refDate) => {
        try {
            const response = await axios.get(`/api/absensi/month/${formatDate01(refDate)}`, {
                withCredentials: true
            });
            setDataAbsensi(response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }

    const getHariLibur = async (refDate) => {
        try {
            const year = refDate.getFullYear();
            const month = refDate.getMonth() + 1;
            const response = await axios.get(`/api/hari-libur/bulan/${year}/${month}`, {
                withCredentials: true
            });
            setHariLibur(response.data || []);
        } catch (error) {
            console.error("Error fetching hari libur:", error);
            setHariLibur([]);
        }
    }

    useEffect(() => {
        getData(dateCurrent)
        getHariLibur(dateCurrent)
    }, [dateCurrent])

    const handleExportExcel = async () => {
        const userId = data?.user?.id_user;
        if (!userId) {
            swal('Error', 'Data user tidak valid', 'error');
            return;
        }

        const y = dateCurrent.getFullYear();
        const m = String(dateCurrent.getMonth() + 1).padStart(2, '0');
        const monthStr = `${y}-${m}`;

        try {
            setExporting(true);
            const response = await axios.get(`/api/absensi/export/${userId}?month=${monthStr}-01`, {
                withCredentials: true,
                responseType: 'blob',
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Rekap_Absensi_${monthStr}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            swal('Success', 'File Excel berhasil diunduh', 'success');
        } catch (error) {
            console.error('Error exporting Excel:', error);
            swal('Error', 'Gagal mengunduh file Excel', 'error');
        } finally {
            setExporting(false);
        }
    };

    const handleDateClick = (date) => {
        const dateStr = formatDate01(date)
        const dayItems = dataAbsensi?.filter(item => formatDate01(item.tanggal) === dateStr) || [];
        const holiday = hariLibur.find(hl => formatDate01(hl.tanggal) === dateStr);

        if (dayItems.length > 0) {
            setModalData(dayItems);
            setModalIsOpen(true);
        } else if (holiday) {
            setModalData([{
                isHoliday: true,
                tanggal: holiday.tanggal,
                nama: holiday.nama,
                keterangan: holiday.keterangan,
                is_nasional: holiday.is_nasional
            }]);
            setModalIsOpen(true);
        } else {
            setModalData(null);
            setModalIsOpen(false);
        }
    };

    const closeModal = () => {
        setModalIsOpen(false);
    }

    const handleActiveStartDateChange = ({ activeStartDate: start }) => {
        if (!start) return;
        setActiveStartDate(start);
        // Pakai awal bulan yang terlihat — jangan spill-over next month
        setDateCurrent(new Date(start.getFullYear(), start.getMonth(), 1));
    };

    return (
        <div className='min-h-[calc(100vh-100px)] bg-whkite pb-[calc(6rem+env(safe-area-inset-bottom))] md:pb-8'>
            {/* <div className='font-semibold py-4 text-xl'> Kalender Absensi</div> */}
            <div className='md:flex md:gap-2 mt-4 space-y-8 md:space-y-0'>
                <div className='kalender px-4 h-full md:pb-8 w-full'>
                    <AttendanceCalendar
                        dataAbsensi={dataAbsensi || []}
                        hariLibur={hariLibur}
                        activeStartDate={activeStartDate}
                        onActiveStartDateChange={handleActiveStartDateChange}
                        onClickDay={handleDateClick}
                        onExportExcel={handleExportExcel}
                        exporting={exporting}
                    />
                </div>

                {/* Hari Libur Section */}
                {hariLibur && hariLibur.length > 0 && (
                    <div className='px-4 pb-[calc(6rem+env(safe-area-inset-bottom))] md:pb-20 w-full'>
                        <div className='bg-white rounded-3xl overflow-hidden p-6 mx-auto' style={{ boxShadow: '0 12px 30px rgba(0, 0, 0, 0.05)' }}>
                            <h3 className='text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2'>
                                <FaCalendarAlt className="text-[#1B3C33]" />
                                Hari Libur {new Date(activeStartDate).toLocaleDateString('id-ID', { month: 'long', year: 'numeric' })}
                            </h3>
                            <div className='space-y-2'>
                                {hariLibur.map((holiday, index) => (
                                    <div
                                        key={index}
                                        className='flex items-start gap-3 p-3 bg-red-50 rounded-lg border-l-4 border-red-400 hover:bg-red-100 transition-colors cursor-pointer'
                                        onClick={() => {
                                            const holidayDate = new Date(holiday.tanggal);
                                            setModalData([{
                                                isHoliday: true,
                                                tanggal: holiday.tanggal,
                                                nama: holiday.nama,
                                                keterangan: holiday.keterangan,
                                                is_nasional: holiday.is_nasional
                                            }]);
                                            setModalIsOpen(true);
                                        }}
                                    >
                                        <div className='flex-shrink-0 mt-1'>
                                            <div className='w-2 h-2 bg-red-500 rounded-full'></div>
                                        </div>
                                        <div className='flex-1'>
                                            <div className='font-semibold text-gray-800 text-sm'>
                                                {formatDate(holiday.tanggal)}
                                            </div>
                                            <div className='text-red-700 font-medium mt-1'>
                                                {holiday.nama}
                                            </div>
                                            {holiday.keterangan && (
                                                <div className='text-xs text-gray-600 mt-1'>
                                                    {holiday.keterangan}
                                                </div>
                                            )}
                                            {holiday.is_nasional && (
                                                <div className='text-xs text-red-600 mt-1 font-medium'>
                                                    Hari Libur Nasional
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}

            </div>
            <AttendanceDetailModal
                isOpen={modalIsOpen}
                onClose={closeModal}
                items={modalData}
            />
        </div>
    );
};

export default Histori;
